// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"style_iconContainer__Q_TtR","icon":"style_icon__omf9c"};